import React, { useEffect, useState } from 'react'
import {
  Card,
  Form,
  Input,
  Button,
  Upload,
  Divider,
  Radio,
  Row,
  Col,
  message,
  Modal,
  Collapse,
  Avatar,
  Tag,
  Spin,
} from 'antd'
import {
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
  ClearOutlined,
  CloseCircleFilled,
} from '@ant-design/icons'

import styles from './create.module.css'
import Dialog from '../dialog/index'
import DialogCreate from '../addKCSDialog/index'
import {
  createBotRequest,
  uploadImgRequest,
  updateBotRequest,
  getBotRequest,
  publishBotRequest,
} from './api'
import { getKcsList, updateBotKnowledgeRequest } from '../addKCSDialog/api'
import { API_URL, HTTP_URL } from '../../../../util/constants'
import { getAliOssToken, uploadAlioss } from '../../../../util/alioss'
import Cookies from 'js-cookie'
import { getSixMathRandom } from '../../../../util/handMath'
const { Panel } = Collapse
const { Meta } = Card
// const API_URL = 'http://ygbhpy.gamepku.com';
const { TextArea } = Input
const getBase64 = (img, callback) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
const AgentCreationPage = (props) => {
  const [messageApi, contextHolder] = message.useMessage()
  const [modal, contextHolder2] = Modal.useModal()
  const [form] = Form.useForm()
  const [templateType, setTemplateType] = useState('custom')
  const [dialogFlag, setDialogFlag] = useState(false)
  const [dialogFlag2, setDialogFlag2] = useState(false)
  const [agentName, setAgentName] = useState('')
  const [agentEasyInfo, setAgentEasyInfo] = useState('')
  const [beginText, setBeginText] = useState('')
  const [beginQuestion, setBeginQuestion] = useState('')
  const [questionList, setQuestionList] = useState([])
  const [tishiText, setTishiText] = useState('')
  const [tishiText2, setTishiText2] = useState('')
  const [selectZhishikuList, setSelectZhishikuList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [zhishikuList, setZhishikuList] = useState([])

  const [iconImg, setIconImg] = useState('')
  const [iconImgUrl, setIconImgUrl] = useState('')
  const [fileList, setFileList] = useState([])
  const [oldBorImgUrl, setOldBorImgUrl] = useState('')
  const [uploadAuto, setUploadAuto] = useState(true)

  const updateSelectZhishikuList = (data) => {
    if (data.ret == 1) {
      let objData = data.botInfo
      getKcsListFn(objData.knowledge.knowledge_infos)
    }
  }

  const deleteSelectZhishikuList = (id) => {
    var id_del = id
    var list2 = zhishikuList
    list2 = list2.filter((item) => item.id !== id_del)
    console.log(list2)
    // setZhishikuList(list2)
    const listNew2 = zhishikuList.map((item) => item.id)
    console.log(listNew2)
    var listNew = listNew2.filter((item) => item !== id_del)
    console.log(listNew)

    setIsLoading(true)

    updateBotKnowledgeRequest(
      {
        bot_id: props.bot_id,
        knowledge: {
          dataset_ids: listNew,
          auto_call: true,
          search_strategy: 0,
        },
      },
      (res) => {
        if (res.ret == 1) {
          message.success('智能体更新成功！')
          setIsLoading(false)
          setZhishikuList(list2)
        } else {
          setIsLoading(false)
          message.error('智能体更新失败')
        }
      },
    )
  }

  //前端水印实现
  function addWatermark(text) {
    const canvas = document.createElement('canvas')
    canvas.width = 300
    canvas.height = 200
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = 'rgba(0,0,0,0.1)'
    ctx.font = '20px Arial'
    ctx.rotate((-20 * Math.PI) / 180)
    ctx.fillText(text, 50, 100)
    document.body.style.backgroundImage = `url(${canvas.toDataURL()})`
  }
  //本地存储过期控制，前端水印实现方案
  //声明一个初始化变量 将这个变量 初始化生命一
  useEffect(() => {
    getAliOssToken()
    if (props.bot_id) {
      //获取智能体配置信息
      getBotRequest(props.bot_id, (data) => {
        if (data.ret == 1) {
          let objData = data.botInfo
          setAgentName(objData.name)
          setAgentEasyInfo(objData.description)
          form.setFieldsValue({
            name: objData.name,
            description: objData.description,
            openingText: objData.onboarding_info.prologue,
            openingQuestions:
              objData.onboarding_info.suggested_questions.join(';'),
          })
          setFileList([
            {
              uid: '-1', // 唯一ID，可以使用图片URL或其他唯一标识
              name: 'default_bot_icon1.png', // 显示的文件名
              status: 'done', // 状态为已完成
              url: objData.icon_url,
            },
          ])
          setOldBorImgUrl(objData.icon_url)
          setBeginText(objData.onboarding_info.prologue)
          setBeginQuestion(
            objData.onboarding_info.suggested_questions.join(';'),
          )
          setQuestionList(objData.onboarding_info.suggested_questions)
          setTishiText(objData.prompt_info.prompt)

          //setZhishikuList(objData.knowledge.knowledge_infos);

          getKcsListFn(objData.knowledge.knowledge_infos)
        }
      })
    }
  }, [])

  const getKcsListFn = (listTmp) => {
    getKcsList(
      {
        space_id: Cookies.get('coze_space_id'),
        // name: agentName,
        name: '',
        format_type: '',
        page_num: 1,
        page_size: 300, //这里接口有问题，page_size不起作用
      },
      (res) => {
        if (res.ret == 1) {
          let result = res.data
          console.log(result)

          const mergedList = listTmp.map((item1) => {
            // 在数组2中查找匹配项
            const matchedItem = result.find(
              (item2) => item2.dataset_id === item1.id,
            )
            // 如果找到匹配项，合并format_type，否则保持原样
            return matchedItem
              ? { ...item1, format_type: matchedItem.format_type }
              : item1
          })

          console.log(mergedList)
          setZhishikuList(mergedList)
        }
      },
    )
  }

  const onFinish = (values) => {
    console.log('Received values:', values)
    message.success('智能体保存成功')
  }

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'||file.type === 'image/jpg'
    if (!isJpgOrPng) {
      message.error('只支持 JPG/JPEG/PNG 格式的图片')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('图片必须小于 2MB!')
    }
    setUploadAuto(isJpgOrPng && isLt2M)
    return isJpgOrPng && isLt2M
  }
  const onClickCancel = () => {
    setDialogFlag(false)
  }
  const onClickCancel2 = () => {
    setDialogFlag2(false)
  }
  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState()
  const handleChange = (info) => {
    if(!uploadAuto){
      setLoading(false)
      return false
    }
    if (info.fileList.length == 2) {
      setFileList([info.fileList[1]])
    } else {
      setFileList(info.fileList)
    }
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false)
        setImageUrl(url)
      })
    }
  }
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      {/*<div*/}
      {/*style={{*/}
      {/*marginTop: 8,*/}
      {/*}}*/}
      {/*>*/}
      {/*Upload*/}
      {/*</div>*/}
    </button>
  )
  const customRequest = async ({ file, onSuccess, onError }) => {
    let aliOssResult = await uploadAlioss({ file, onSuccess, onError })
    if (aliOssResult.ret == 1) {
      setIconImgUrl(aliOssResult.url)
      try {
        // 生成新文件名（可根据需求修改）
        const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
        const newFileName = `img_${Date.now()}_${Cookies.get('user_login')}.${fileExt}`;
        // 调用你的上传接口
        await uploadImgRequest(file, newFileName, (data) => {
          if (data.ret == 1) {
            // const fileUrl = `${API_URL}/icons/${newFileName}`;
            // onSuccess({ ...file, url: fileUrl }, file);
            // onUploadSuccess?.(fileUrl); // 可选：通知父组件上传成功
            file.url = API_URL + '/icons/' + newFileName
            // file.name = newFileName
            onSuccess(file)
            setIconImg(data.imgInfo.id)
          } else {
            onError(data)
            message.error('上传失败: ' + (data.message || '未知错误'))
          }
        })
      } catch (error) {
        onError(error)
        message.error('上传失败: ' + error.message)
      }
    } else {
      onError(aliOssResult.msg)
    }
  }

  const changeAgentName = (e) => {
    setAgentName(e.target.value)
  }
  const changeAgentEasyInfo = (e) => {
    setAgentEasyInfo(e.target.value)
  }
  const changeBeginText = (e) => {
    setBeginText(e.target.value)
  }
  const changeBeginQuestion = (e) => {
    setBeginQuestion(e.target.value)
    setQuestionList(e.target.value.split(';'))
  }
  const onSetValueFn = (value, flag) => {
    setTishiText(value)
    setDialogFlag(flag)
  }
  const onSetValueFn2 = (value, flag) => {
    setTishiText2(value)
    setDialogFlag2(flag)
  }
  const changeTishiText = (e) => {
    setTishiText(e.target.value)
  }
  const addKCSKu = () => {
    setDialogFlag2(true)
  }

  const closeCreateModal = () => {
    props.onCreateClose()
  }

  const showCreateZhishikuDialog = () => {
    props.showCreateZhishikuDialog()
  }

  return (
    <div className={styles.root}>
      {contextHolder}
      {contextHolder2}

      <Card
        title={
          <div className="title_box">
            {dialogFlag2 ? (
              <DialogCreate
                bot_id={props.bot_id}
                // zhishikuList={zhishikuList}
                // visible={dialogFlag2}
                visible={true}
                onCancel={onClickCancel2}
                setValue={onSetValueFn2}
                agentName={agentName}
                onOk={updateSelectZhishikuList}
                showCreateZhishikuDialog={showCreateZhishikuDialog}
                onSuccess={updateSelectZhishikuList}
              />
            ) : null}

            <div
              style={{
                textAlign: 'left',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <img
                src={require('../img/ic_back.png')}
                style={{
                  width: 15,
                  height: 15,
                  marginRight: 10,
                  zIndex: 999,
                  cursor: 'pointer',
                }}
                onClick={() => props.onCreateClose()}
              />

              <span
                className={styles.title}
                style={{ marginLeft: '0%', fontWeight: 500 }}
              >
                {props.bot_id ? '更新智能体' : '创建智能体'}
              </span>

              {/*<span style={{ marginRight: '315%' }}>*/}
              {/*{props.id ? '更新智能体' : '创建智能体'}*/}
              {/*</span>*/}
              <span
                className={styles['text-bianpai']}
                style={{ fontWeight: 500 }}
              >
                编排
              </span>
            </div>
            <div style={{ textAlign: 'right' }}>
              {props.bot_id ? (
                <Button
                  className={styles['bt-yulan']}
                  style={{ marginRight: 16, color: '#2772F0' }}
                  onClick={() => {
                    window.open(
                      HTTP_URL +
                        `/gongju/preview/index.html?botId=${props.bot_id}&icon=${btoa(oldBorImgUrl)}&title=${agentName}&userToken=` +
                        Cookies.get('userToken'),
                    )
                  }}
                  disabled={props.bot_id ? false : true}
                >
                  预览
                </Button>
              ) : null}
              <Button
                className={styles['bt-fabu']}
                type="primary"
                onClick={(e) => {
                  form
                    .validateFields()
                    .then((values) => {
                      if (iconImg || props.bot_id) {
                        modal.confirm({
                          title: props.bot_id
                            ? '您确认更新该智能体？'
                            : '您确认新建该智能体？',
                          icon: <ExclamationCircleOutlined />,

                          okText: '确认',
                          cancelText: '取消',
                          onOk() {
                            setIsLoading(true)

                            if (!props.bot_id) {
                              createBotRequest(
                                Cookies.get('coze_space_id'),
                                agentName,
                                agentEasyInfo,
                                iconImg,
                                iconImgUrl,
                                tishiText,
                                beginText,
                                JSON.stringify(questionList),
                                (data) => {
                                  console.log(data)
                                  if (data.ret == 1) {
                                    setIsLoading(false)
                                    message.success('智能体新建成功！')
                                    setTimeout(() => {
                                      props.onChange(false)
                                    }, 2000)
                                  } else {
                                    setIsLoading(false)
                                    message.error(data.msg)
                                  }
                                },
                              )
                            } else {
                              let formObj = form.getFieldValue()
                              updateBotRequest(
                                props.bot_id,
                                agentName,
                                agentEasyInfo,
                                iconImg,
                                iconImgUrl,
                                tishiText,
                                beginText,
                                // JSON.stringify(
                                //     formObj.openingQuestions.split(
                                //         ';'
                                //     )
                                // ),
                                questionList,
                                (data) => {
                                  console.log(data)
                                  if (data.ret == 1) {
                                    setIsLoading(false)
                                    message.success('智能体保存成功！')
                                    setTimeout(() => {
                                      props.onChange(false)
                                    }, 2000)
                                  } else {
                                    setIsLoading(false)
                                    message.success('智能体保存失败！')
                                  }
                                },
                              )
                            }
                          },
                          onCancel() {
                            console.log('Cancel')
                          },
                        })
                      } else {
                        message.error('请上传头像')
                      }
                    })
                    .catch((errorInfo) => {
                      console.log('校验失败:', errorInfo)
                    })
                  return
                }}
              >
                保存
              </Button>

              {props.showPublishButton ? (
                <Button
                  className={styles['bt-fabu']}
                  style={{ marginLeft: 16 }}
                  type="primary"
                  onClick={(e) => {
                    form
                      .validateFields()
                      .then((values) => {
                        if (iconImg || props.bot_id) {
                          modal.confirm({
                            title: '确认发布此智能体',
                            icon: <ExclamationCircleOutlined />,

                            okText: '确认',
                            cancelText: '取消',
                            onOk() {
                              setIsLoading(true)
                              let formObj = form.getFieldValue()
                              publishBotRequest(
                                props.bot_id,
                                agentName,
                                agentEasyInfo,
                                iconImg,
                                iconImgUrl,
                                tishiText,
                                beginText,
                                questionList,
                                (data) => {
                                  console.log(data)
                                  if (data.ret == 1) {
                                    setIsLoading(false)
                                    message.success('智能体发布成功！')
                                    setTimeout(() => {
                                      props.onChange(false)
                                    }, 2000)
                                  } else {
                                    setIsLoading(false)
                                    message.success('智能体发布失败！')
                                  }
                                },
                              )
                            },
                            onCancel() {
                              console.log('Cancel')
                            },
                          })
                        } else {
                          message.error('请上传头像')
                        }
                      })
                      .catch((errorInfo) => {
                        console.log('校验失败:', errorInfo)
                      })
                    return
                  }}
                >
                  更新并发布
                </Button>
              ) : null}
            </div>
          </div>
        }
        bordered={false}
        className="create_card"
      >
        <Form
          className="create_form"
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          {/* 基本信息部分 */}
          <Card
            title=""
            style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: 4 }}
            className={styles.myform}
          >
            <div className={styles.title} style={{ marginBottom: 15 }}>
              智能体名称 <div style={{ color: 'red', marginLeft: 2 }}>※</div>
            </div>

            <Input
              className={styles.input1}
              placeholder="为智能体起个独特的名字"
              maxLength={20}
              showCount
              allowClear
              value={agentName}
              onChange={changeAgentName}
            />

            <div
              className={styles.title}
              style={{ marginTop: 15, marginBottom: 15 }}
            >
              智能体功能介绍{' '}
              <div style={{ color: 'red', marginLeft: 2 }}>※</div>
            </div>

            <div className={styles['div-textarea']}>
              <TextArea
                className={styles.textarea1}
                style={{
                  resize: 'none',
                  outline: 'none',
                  paddingBottom: 20,
                  // 隐藏滚动条的核心样式
                  '::-webkit-scrollbar': { display: 'none' }, // Chrome/Safari
                  '-ms-overflow-style': 'none', // IE/Edge
                  'scrollbar-width': 'none', // Firefox
                }}
                rows={4}
                placeholder="输入对智能体的描述，包括功能特色，将会展示给智能体的用户"
                allowClear
                maxLength={500}
                showCount={false}
                value={agentEasyInfo}
                onChange={changeAgentEasyInfo}
              />

              <div className={styles['custom-count']}>
                {agentEasyInfo.length}/{500}
              </div>
            </div>

            <Row gutter={16}>
              <Col span={12}>
                <div
                  className={styles.title}
                  style={{ marginTop: 10, marginBottom: 10 }}
                >
                  头像<div style={{ color: 'red', marginLeft: 2 }}>※</div>
                </div>

                <Upload
                  fileList={fileList}
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  customRequest={customRequest}
                  showUploadList={true}
                  accept=".jpg,.jpeg,.png"
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <div style={{ marginTop: 8,width:'300px' }}>
                  只支持.jpg、.jpeg、.png格式，最大不超过2MB
                </div>
              </Col>
            </Row>
          </Card>

          {/* 人设回复与逻辑部分 */}
          <Card
            style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: 4 }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <span className={styles.title}>人设回复与逻辑</span>
              <span
                style={{ color: '#1677ff', cursor: 'pointer' }}
                onClick={() => setDialogFlag(true)}
              >
                查看提示词库
              </span>
            </div>
            <TextArea
              className={styles.textarea1}
              style={{
                background: '#fffffa',
                resize: 'none',
                // 隐藏滚动条的核心样式
                '::-webkit-scrollbar': { display: 'none' }, // Chrome/Safari
                '-ms-overflow-style': 'none', // IE/Edge
                'scrollbar-width': 'none', // Firefox
              }}
              rows={20}
              placeholder="输入/自动编写提示词或输入插入已配置的技能"
              value={tishiText}
              allowClear
              onChange={changeTishiText}
            />
          </Card>

          {/* 对话体验部分 */}

          <Card
            style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: 4 }}
          >
            <div className={styles.title} style={{ marginBottom: 10 }}>
              智能体功能介绍
            </div>

            <Collapse defaultActiveKey={['1']}>
              <Panel header="对话体验" key="1">
                {/*<Form.Item label='开场白文案' name='openingText'>*/}
                {/*<TextArea*/}
                {/*rows={4}*/}
                {/*placeholder='输入正文'*/}
                {/*value={beginText}*/}
                {/*onChange={changeBeginText}*/}
                {/*/>*/}
                {/*</Form.Item>*/}

                <div style={{ marginTop: -5, marginBottom: 10 }}>
                  开场白文案
                </div>

                <div className={styles['div-textarea']}>
                  <TextArea
                    className={styles.textarea1}
                    style={{
                      resize: 'none',
                      paddingBottom: 20,
                      // 隐藏滚动条的核心样式
                      '::-webkit-scrollbar': { display: 'none' }, // Chrome/Safari
                      '-ms-overflow-style': 'none', // IE/Edge
                      'scrollbar-width': 'none', // Firefox
                    }}
                    rows={4}
                    placeholder="输入正文"
                    allowClear
                    maxLength={200}
                    showCount={false}
                    value={beginText}
                    onChange={changeBeginText}
                  />

                  <div className={styles['custom-count']}>
                    {beginText.length}/{200}
                  </div>
                </div>

                <div style={{ marginTop: 10, marginBottom: 10 }}>
                  开场白预制问题
                </div>

                <Input
                  className={styles.input1}
                  placeholder="输入开场白预制问题"
                  allowClear
                  value={beginQuestion}
                  onChange={changeBeginQuestion}
                />
                {/*<Form.Item label='开场白预置问题' name='openingQuestions'>*/}
                {/*<TextArea*/}
                {/*rows={1}*/}
                {/*placeholder='添加多个预置问题，用英文分号隔开'*/}
                {/*value={beginQuestion}*/}
                {/*onChange={changeBeginQuestion}*/}
                {/*/>*/}
                {/*</Form.Item>*/}
              </Panel>
            </Collapse>

            {/*<Form.Item label='开场白文案' name='openingText'>*/}
            {/*<TextArea*/}
            {/*rows={4}*/}
            {/*placeholder='输入正文'*/}
            {/*value={beginText}*/}
            {/*onChange={changeBeginText}*/}
            {/*/>*/}
            {/*</Form.Item>*/}

            {/*<Form.Item label='开场白预置问题' name='openingQuestions'>*/}
            {/*<TextArea*/}
            {/*rows={4}*/}
            {/*placeholder='添加多个预置问题，用英文分号隔开'*/}
            {/*value={beginQuestion}*/}
            {/*onChange={changeBeginQuestion}*/}
            {/*/>*/}
            {/*</Form.Item>*/}

            {/*{props.id ? (*/}
            {/*<div*/}
            {/*className={styles.title}*/}
            {/*style={{marginTop:15,marginBottom:10}}*/}
            {/*>*/}
            {/*知识库*/}
            {/*</div>):null}*/}

            {props.bot_id ? (
              <Form.Item label="" name="">
                <Collapse defaultActiveKey={['1', '2']}>
                  <Panel
                    header="文本"
                    key="1"
                    extra={
                      <PlusOutlined
                        onClick={(event) => {
                          addKCSKu()
                          // If you don't want click extra trigger collapse, you can prevent this:
                          event.stopPropagation()
                        }}
                      />
                    }
                  >
                    {zhishikuList.filter((item) => item.format_type === 0)
                      .length === 0 ? (
                      <div style={{ marginBottom: 10 }}>
                        将文档、URL、三方数据源上传为文本知识库后，用户发送消息时，智能体能够引用文本知识中的内容回答用户问题。
                      </div>
                    ) : null}

                    {zhishikuList
                      .filter((item) => item.format_type === 0)
                      .map((item2, i) => (
                        <div className="meta_box_my">
                          <Meta
                            avatar={
                              <Avatar
                                style={{
                                  borderRadius: '8px',
                                  width: 30,
                                  height: 30,
                                }}
                                src={require('../img/dataset_text.png')}
                              />
                            }
                            title={item2.name}
                            description={item2.description}
                            style={{ marginBottom: '15px' }}
                            className="my_meta"
                          ></Meta>
                          <div>
                            <ClearOutlined
                              onClick={() => {
                                deleteSelectZhishikuList(item2.id)
                              }}
                            />
                          </div>
                        </div>
                      ))}
                  </Panel>
                  <Panel
                    header="照片"
                    key="2"
                    extra={
                      <PlusOutlined
                        onClick={(event) => {
                          addKCSKu()
                          // If you don't want click extra trigger collapse, you can prevent this:
                          event.stopPropagation()
                        }}
                      />
                    }
                  >
                    {zhishikuList.filter((item) => item.format_type === 2)
                      .length === 0 ? (
                      <div>
                        照片上传到知识库后自动/手动添加语义描述，智能体可以基于照片的描述匹配到最合适的照片
                      </div>
                    ) : null}

                    {zhishikuList
                      .filter((item) => item.format_type === 2)
                      .map((item2, i) => (
                        <div className="meta_box_my">
                          <Meta
                            avatar={
                              <Avatar
                                style={{
                                  borderRadius: '8px',
                                  width: 30,
                                  height: 30,
                                }}
                                src={require('../img/dataset_image.png')}
                              />
                            }
                            title={item2.name}
                            description={item2.description}
                            style={{ marginBottom: '15px' }}
                            // className='my_meta'
                          ></Meta>
                          <div>
                            <ClearOutlined
                              onClick={() => {
                                deleteSelectZhishikuList(item2.id)
                              }}
                            />
                          </div>
                        </div>
                      ))}
                  </Panel>
                </Collapse>
              </Form.Item>
            ) : null}
          </Card>
        </Form>
      </Card>
      <Dialog
        visible={dialogFlag}
        onCancel={onClickCancel}
        setValue={onSetValueFn}
      />
      {/*{agentName ? (*/}
      {/*<DialogCreate*/}
      {/*visible={dialogFlag2}*/}
      {/*onCancel={onClickCancel2}*/}
      {/*setValue={onSetValueFn2}*/}
      {/*agentName={agentName}*/}
      {/*/>*/}
      {/*) : null}*/}
      {isLoading ? (
        <Spin
          size="large"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
          }}
        />
      ) : null}
    </div>
  )
}

export default AgentCreationPage
